var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 Z",
    id: "path-1-pores"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFP-Imagery",
    transform: "translate(-212.000000, -252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/36px/Pores",
    transform: "translate(214.000000, 254.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1-pores"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.03,
    fill: "#27CAE3",
    xlinkHref: "#path-1-pores"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M18,37 C7.50658975,37 -1,28.4934102 -1,18 C-1,7.50658975 7.50658975,-1 18,-1 C28.4934102,-1 37,7.50658975 37,18 C37,28.4934102 28.4934102,37 18,37 Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.04,
    stroke: "#00ADC6",
    strokeWidth: 1,
    d: "M18,35.5 C27.6649831,35.5 35.5,27.6649831 35.5,18 C35.5,8.33501688 27.6649831,0.5 18,0.5 C8.33501688,0.5 0.5,8.33501688 0.5,18 C0.5,27.6649831 8.33501688,35.5 18,35.5 Z",
    strokeLinejoin: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.778,25.778 C23.7,27.856 20.937,29 18,29 C15.062,29 12.299,27.856 10.221,25.778 C8.624,24.18 7.585,22.176 7.187,20 L14.424,20 C14.322,20.221 14.224,20.447 14.135,20.676 C13.897,21.297 13.171,23.184 14.412,25.069 C15.21,26.278 16.55,27 18,27 C19.449,27 20.79,26.278 21.588,25.068 C22.384,23.858 22.519,22.341 21.949,21.01 L21.516,20 L28.812,20 C28.415,22.176 27.376,24.18 25.778,25.778 M10.221,10.221 C12.299,8.144 15.062,7 18,7 C20.937,7 23.7,8.144 25.778,10.221 C26.605,11.049 27.277,11.987 27.795,13 L24,13 L24,11 L19,14 C18.963,14 24,17 24,17 L24,15 L28.579,15 C28.851,15.965 29,16.97 29,18 L20,18 C19.664,18 19.35,18.169 19.165,18.449 C18.98,18.73 18.948,19.085 19.081,19.394 L20.111,21.798 C20.416,22.509 20.343,23.321 19.918,23.967 C19.491,24.613 18.774,25 18,25 C17.225,25 16.508,24.613 16.082,23.967 C15.602,23.24 15.579,22.494 16.003,21.395 C16.159,20.988 16.35,20.597 16.53,20.226 C16.671,19.937 16.805,19.658 16.919,19.393 C17.051,19.084 17.019,18.73 16.835,18.449 C16.649,18.169 16.336,18 16,18 L7,18 C7,16.97 7.148,15.965 7.421,15 L12,15 L12,17 L17,14 C17.037,14 12,10.999 12,10.999 L12,13 L8.205,13 C8.722,11.987 9.394,11.049 10.221,10.221 M27.192,8.807 C24.736,6.352 21.471,5 18,5 C14.528,5 11.263,6.352 8.807,8.807 C6.352,11.262 5,14.527 5,18 C5,21.472 6.352,24.737 8.807,27.192 C11.263,29.648 14.528,31 18,31 C21.471,31 24.736,29.648 27.192,27.192 C29.647,24.737 31,21.472 31,18 C31,14.527 29.647,11.262 27.192,8.807",
    id: "Fill-1",
    fillOpacity: 0.65,
    fill: "#27CAE3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPores);
export default __webpack_public_path__ + "static/media/Pores.60d38e79e9c28cd70f8a84592aa360d7.svg";
export { ForwardRef as ReactComponent };